import { updatedRouteSetup } from "./router";

const mainModule = (module as unknown as {
    hot: {
        addStatusHandler: (callback: () => void) => void,
    },
});

if (mainModule.hot) {
    mainModule.hot.addStatusHandler(updatedRouteSetup);
}